import { global } from ":shared/app";

export const is_dev = global.helper.env.isDev;
export const mocks = {
  // eslam on mail.tm, password same as email on mail.tm
  eslam_hd_part: {
    email: "wendelinebeige@e-record.com",
    password: "Hello@123", // orjm3(K"s:
  },
};
